export default function getMfa(state) {
  if (state.loginForm && state.loginForm.mfa) {
    return state.loginForm.mfa;
  }
}